export default __webpack_public_path__ + "static/media/Malote.d68b3cf9.svg";